import React from 'react';
import {useTranslation} from 'react-i18next';
import {Hand} from 'lucide-react';
import {
  TutorialOverlay,
  TutorialContent,
  HandIconWrapper,
  TutorialText,
  TutorialHint,
  SwipeLabelsContainer,
  SwipeLabel,
} from './styled';

type SwipeTutorialProps = {
  onDismiss: () => void;
};

export const SwipeTutorial = React.memo(function SwipeTutorial({
  onDismiss,
}: SwipeTutorialProps) {
  const {t} = useTranslation();

  return (
    <TutorialOverlay onClick={onDismiss}>
      <TutorialContent>
        <SwipeLabelsContainer>
          <SwipeLabel $direction="left">{t('skip')}</SwipeLabel>
          <SwipeLabel $direction="right">{t('enhance_your_stay.add_to_cart')}</SwipeLabel>
        </SwipeLabelsContainer>

        <HandIconWrapper>
          <Hand color="white" />
        </HandIconWrapper>

        <TutorialText>{t('enhance_your_stay.tutorial_text')}</TutorialText>

        <TutorialHint>{t('enhance_your_stay.tap_to_dismiss')}</TutorialHint>
      </TutorialContent>
    </TutorialOverlay>
  );
});
